import React, { useState, useEffect } from "react";
import {
  Input,
  InputGroup,
  Col,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  UncontrolledDropdown,
  Button,
  Row,
} from "reactstrap";
import Grid from "./Item/Grid";
import style from "./style.module.scss";
import InfiniteScroll from "react-infinite-scroller";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";

const loader = (
  <div className={style.spinner} key={0}>
    <div className={style.bounce1} />
    <div className={style.bounce2} />
    <div className={style.bounce3} />
  </div>
);

const CrossReferenceSearch = ({ fetchs, Link }) => {
  const [crossReference, setCrossReference] = useState({
    arr: [],
    loading: true,
    hasMore: false,
  });
  const [processes, setProcesses] = useState({ arr: [], selected: "All" });
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchs.getProcesses({}).then((r) => {
      setProcesses({ ...processes, arr: r.processes });
    });
    fetchs
      .getCrossReferenceSearch({
        text: search,
        fromRow: 0,
        process: processes.selected,
      })
      .then((r) => {
        var hasMore = true;
        if (r.crossReferences.length < 50) {
          hasMore = false;
        }
        setCrossReference({
          ...crossReference,
          arr: r.crossReferences,
          loading: false,
          hasMore: hasMore,
        });
      });
  }, []);

  const searchCrossReference = (event) => {
    setCrossReference({
      ...crossReference,
      arr: [],
      loading: true,
    });
    fetchs
      .getCrossReferenceSearch({
        text: search,
        fromRow: 0,
        process: processes.selected,
      })
      .then((r) => {
        var hasMore = true;
        if (r.crossReferences.length < 50) {
          hasMore = false;
        }
        setCrossReference({
          ...crossReference,
          arr: r.crossReferences,
          loading: false,
          hasMore: hasMore,
        });
      });
  };

  const filterList = (event) => {
    setSearch(event.target.value);
  };

  const loadItems = () => {
    fetchs
      .getCrossReferenceSearch({
        text: search,
        fromRow: crossReference.arr.length,
        process: processes.selected,
      })
      .then((r) => {
        let temp = crossReference.arr;
        var hasMore = true;
        if (r.crossReferences.length !== 0) {
          r.crossReferences.forEach((elem) => temp.push(elem));
        }
        if (r.crossReferences.length < 50) {
          hasMore = false;
        }
        setCrossReference({
          ...crossReference,
          arr: temp,
          loading: false,
          hasMore: hasMore,
        });
      });
  };

  const changeProcess = (event) => {
    setProcesses({
      ...processes,
      selected: event.target.value,
    });
  };

  return (
    <div>
      <Row className={style.toolbar}>
        <Col md={6}>
          <InputGroup className={style.searchBar}>
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="fa fa-search"></i>
              </span>
            </div>

            <Input type="text" placeholder="Search ticket" value={search} onChange={filterList} />
          </InputGroup>
        </Col>
        <Col md={2}>
          <UncontrolledDropdown>
            <DropdownToggle caret className={style.buttonFormat}>
              {processes.selected}
            </DropdownToggle>
            <DropdownMenu
              modifiers={{
                setMaxHeight: {
                  enabled: true,
                  order: 890,
                  fn: (data) => {
                    return {
                      ...data,
                      styles: {
                        ...data.styles,
                        overflow: "auto",
                        maxHeight: "300px",
                      },
                    };
                  },
                },
              }}
            >
              {processes.arr.map((item, index) => (
                <DropdownItem value={item} data-id={item} onClick={changeProcess} key={`item-${index}`}>
                  {item}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </UncontrolledDropdown>
        </Col>
        <Col>
          <LaddaButton
            className="btn btn-ladda btn-primary ml-2 mr-2"
            loading={false}
            disabled={false}
            onClick={() => searchCrossReference()}
            data-style={EXPAND_RIGHT}
          >
            Search
          </LaddaButton>
        </Col>
      </Row>
      <InfiniteScroll pageStart={0} loadMore={loadItems} hasMore={crossReference.hasMore} loader={loader}>
        <Grid loading={crossReference.loading} crossReferences={crossReference.arr} Link={Link} />
      </InfiniteScroll>
    </div>
  );
};

export default CrossReferenceSearch;
